import { TableConfigV2 } from 'hooks/useMuiTableBuilderV2';
import { HeaderCell } from 'components/Cells/HeaderCell';
import { columns, COLUMNS } from './columns';
import { DataDeletionCheckboxCell } from './DataCells/DataDeletionCheckboxCell';
import { DataDeletionTenantCell } from './DataCells/DataDeletionTenantCell';
import { DataDeletionRealmCell } from './DataCells/DataDeletionRealmCell';
import { DataDeletionTeamIdCell } from './DataCells/DataDeletionTeamIdCell';
import { DataDeletionTeamNameCell } from './DataCells/DataDeletionTeamNameCell';
import { DataDeletionArchivedAtCell } from './DataCells/DataDeletionArchivedAtCell';
import { DataDeletionDeletionDateCell } from './DataCells/DataDeletionDeletionDateCell';
import { DataDeletionDeveloperApprovalCell } from './DataCells/DataDeletionDeveloperApprovalCell';
import { DataDeletionSupportApprovalCell } from './DataCells/DataDeletionSupportApprovalCell';
import { DataDeletionReasonCell } from './DataCells/DataDeletionReasonCell';
import { DataDeletionCheckboxHeaderCell } from './HeaderCells/DataDeletionCheckboxHeaderCell';

export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
};

export const getTableConfig = (): TableConfigV2 => {
  return {
    hasStickyHeader: true,
    tableHeaderTitle: 'Teams Scheduled for Deletion',
    rowTypes: ROW_TYPES,
    hideToolbar: false,
    columns,
    columnsMinWidth: {
      [COLUMNS.CHECKBOX]: 40,
    },
    cellsByRowTypesAndColumns: {
      [ROW_TYPES.DATA]: {
        [COLUMNS.CHECKBOX]: DataDeletionCheckboxCell,
        [COLUMNS.TENANT]: DataDeletionTenantCell,
        [COLUMNS.REALM]: DataDeletionRealmCell,
        [COLUMNS.TEAM_ID]: DataDeletionTeamIdCell,
        [COLUMNS.TEAM_NAME]: DataDeletionTeamNameCell,
        [COLUMNS.ARCHIVED_AT]: DataDeletionArchivedAtCell,
        [COLUMNS.DELETION_DATE]: DataDeletionDeletionDateCell,
        [COLUMNS.DEVELOPER_APPROVAL]: DataDeletionDeveloperApprovalCell,
        [COLUMNS.SUPPORT_APPROVAL]: DataDeletionSupportApprovalCell,
        [COLUMNS.REASON]: DataDeletionReasonCell,
      },
      [ROW_TYPES.HEADER]: {
        [COLUMNS.CHECKBOX]: DataDeletionCheckboxHeaderCell,
        [COLUMNS.TENANT]: HeaderCell,
        [COLUMNS.REALM]: HeaderCell,
        [COLUMNS.TEAM_ID]: HeaderCell,
        [COLUMNS.TEAM_NAME]: HeaderCell,
        [COLUMNS.ARCHIVED_AT]: HeaderCell,
        [COLUMNS.DELETION_DATE]: HeaderCell,
        [COLUMNS.DEVELOPER_APPROVAL]: HeaderCell,
        [COLUMNS.SUPPORT_APPROVAL]: HeaderCell,
        [COLUMNS.REASON]: HeaderCell,
      },
    },
  };
};
